var scrollEnded = function scrollEnded(elementTarget) {
  var scrollEndOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return elementTarget.offsetHeight + elementTarget.scrollTop >= elementTarget.scrollHeight - scrollEndOffset;
};
export default scrollEnded;